import {configJson, getHttp} from "./config/http-configs";

export const getApplyListByPinCode = (pinCode) => {
    return getHttp().get(`/mobile/apply/enter/pin/${pinCode}`)
}

export const getApplyListByVisitCode = (visitCode) => {
    return getHttp().get(`/mobile/apply/enter/id/${visitCode}`)
}

// 动态访客码（小程序展示的 15 秒刷新码 / 纸质访客码，t_qr_link）
export const getApplyListByQrCode = (qrCode) => {
    return getHttp().get(`/mobile/apply/enter/qr/${qrCode}`)
}
export const getUserInfo = (visitorCode) => {
    return getHttp().get(`/mobile/visitor/list/${visitorCode}`)
}

export const signEnter = (applyId, visitorCode, enterDeviceId, enterAreaId, photoKey, certPhoto, icCompareResult, icCompareScore, enterCardNo) => {
    let url = `/mobile/record/enter`
    let data = {applyId: applyId, visitorCode: visitorCode, enterDeviceId: enterDeviceId, enterAreaId: enterAreaId}
    if (enterCardNo) {
        // 访客编码=前台发给访客的实物卡编号，后端落 vt_record.enter_card_no
        data.enterCardNo = enterCardNo
    }
    if (photoKey) {
        data.enterPhoto = photoKey
    }
    if (certPhoto) {
        data.certPhoto = certPhoto
    }
    if (icCompareResult) {
        data.icCompareResult = icCompareResult
    }
    if (icCompareScore) {
        data.icCompareScore = icCompareScore
    }
    return getHttp().post(url, data, configJson)
}

export const signLeave = (applyId, visitorCode, leaveDeviceId, leaveAreaId) => {
    let url = `/mobile/record/leave`
    let data = {applyId: applyId, visitorCode: visitorCode, leaveDeviceId: leaveDeviceId, leaveAreaId: leaveAreaId}
    return getHttp().post(url, data, configJson)
}

export const visitorSearchByIdCardNo = (idCardNo) => {
    const url = "/mobile/visitor/search"
    const data = {ic: idCardNo}
    return getHttp().post(url, data, configJson)
}

export const visitorSearchByPhoneNo = (tel) => {
    const url = "/mobile/visitor/search"
    const data = {tel: tel}
    return getHttp().post(url, data, configJson)
}

export const visitorUpdate = (id, head) => {
    const url = `/mobile/visitor/scene/update`
    const data = {id: id, head: head}
    return getHttp().post(url, data, configJson)
}

export const usualVisitorSignEnter = (data) => {
    const url = `/mobile/record/enter/usual`
    return getHttp().post(url, data, configJson)
}

export const usualVisitorSignLeave = (data) => {
    const url = `mobile/record/leave/usual`
    return getHttp().post(url, data, configJson)
}
